module.exports = __webpack_public_path__ + "img/battery-high.f87ae121.svg";